export enum CurrentEmploymentInputLabel {
  EmployerName = 'Employer Name',
  Position = 'Position',
  EmployerPhone = 'Employer Phone',
  HireDate = 'Hire Date',
  Address = 'Employer Street Address',
  State = 'Employer State',
  City = 'Employer City',
  Zip = 'Employer Zip Code',
}

export enum CurrentEmploymentVariable {
  EmployerName = 'borrower_current_employer',
  Position = 'borrower_position',
  EmployerPhone = 'borrower_employer_phone',
  HireDate = 'borrower_hire_date',
  Address = 'borrower_employer_street_address',
  State = 'borrower_employer_state',
  City = 'borrower_employer_city',
  Zip = 'borrower_employer_zip',
  GovernmentPaygrade = 'borrower_government_paygrade',
  BranchOfService = 'borrower_branch_of_service',
  MilitaryPaygrade = 'borrower_military_paygrade',
  RetirementDate = 'borrower_retirement_date',
  RetiredBranchOfService = 'borrower_branch_of_service_retired',
  RetiredMilitaryPaygrade = 'borrower_military_paygrade_retired',
  EmploymentStatus = 'borrower_employment_status',
}

export enum PreviousEmploymentVariable {
  EmployerName = 'borrower_previous_employer_1',
  Position = 'borrower_previous_employer_1_position',
  EmployerPhone = 'borrower_previous_employer_1_phone',
  HireDate = 'borrower_previous_employer_1_hire_date',
  Address = 'borrower_previous_employer_1_street_address',
  State = 'borrower_previous_employer_1_state',
  City = 'borrower_previous_employer_1_city',
  Zip = 'borrower_previous_employer_1_zip',
  EmploymentStatus = 'borrower_previous_employment_status_1',
}

export enum PreviousEmploymentInputLabel {
  EmployerName = 'Employer Name',
  Position = 'Position',
  EmployerPhone = 'Employer Phone',
  HireDate = 'Hire Date',
  Address = 'Employer Street Address',
  State = 'Employer State',
  City = 'Employer City',
  Zip = 'Employer Zip',
  EmploymentStatus = 'Employment Status',
}

export enum ContractorInformationFormVariableName {
  Name = 'fundedContractorName',
  SalespersonName = 'fundedContractorSalespersonName',
  SalespersonPhone = 'fundedContractorSalespersonPhone',
  SalespersonEmail = 'fundedContractorSalespersonEmail',
}

export enum ContractorInformationInputLabel {
  Name = 'Contractor Name',
  SalespersonName = 'Contractor Salesperson Name',
  SalespersonPhone = 'Contractor Salesperson Phone',
  SalespersonEmail = 'Contractor Salesperson Email',
}

export enum EmploymentStatusInformationInputLabel {
  BranchOfService = 'Branch Of Service',
  MilitaryPaygrade = 'Military Paygrade',
  GovernmentPaygrade = 'Government Paygrade',
  RetirementDate = 'Retirement Date',
  RetiredBranchOfService = 'Branch Of Service',
  RetiredMilitaryPaygrade = 'Military Paygrade',
}
